export const initUiInput = () => {
  const uiInputControlSelector = $(".ui-input__control");
  const NOT_EMPTY = "not-empty";
  const IS_DISABLED = "is-disabled";

  if (uiInputControlSelector.length) {
    uiInputControlSelector.each(function() {
      $(this).keyup(function() {
        if (this.value) {
          $(this)
            .closest(".ui-input")
            .addClass(NOT_EMPTY);
        } else {
          $(this)
            .closest(".ui-input")
            .removeClass(NOT_EMPTY);
        }
      });

      if ($(this).next(".ui-button").length) {
        $(this)
          .next()
          .on("click", function() {
            $(this)
              .prev()
              .val("");
            $(this)
              .prev()
              .closest(".ui-input")
              .removeClass(NOT_EMPTY);
          });
      }

      if ($(this).is(":disabled")) {
        $(this)
          .closest(".ui-input")
          .addClass(IS_DISABLED);
      } else {
        $(this)
          .closest(".ui-input")
          .removeClass(IS_DISABLED);
      }
    });
  }
};
